import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'reformatTime',
    standalone: false,
})
export class ReformatTimePipe implements PipeTransform {
    transform(time: string, oldFormat: string, newFormat: string): string {
        return moment(time, oldFormat).format(newFormat);
    }
}
